class PickupAvailability extends HTMLElement {
    constructor() {
        super();

        if (!this.hasAttribute('available')) {
            return;
        }

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
    }
    
    updatePDPContactLink(metaDescriptionSection, productTitle, productSKU) {
        if (!metaDescriptionSection || !productTitle || !productSKU) {
          console.warn("Required product information not found.");
          return;
        }
        
        const contactUsLink = metaDescriptionSection.querySelectorAll("a");
        
        if (contactUsLink.length === 0) {
          console.warn("No links found.");
          return;
        }
      
        const productInfo = {
          title: productTitle.trim(),
          sku: productSKU.trim()
        };
      
        if (!productInfo.title || !productInfo.sku) {
          console.warn("Product title or SKU is empty");
          return;
        }
        
        try {
          localStorage.setItem('ptspeed_product_info', JSON.stringify(productInfo));
        } catch (e) {
          console.log('Failed to save to localStorage:', e);
        }
        
        const contactLinksMatch = [
          'https://www.ptspeed.com/pages/contact',
          '/pages/contact',
          'https://store.pactech-inc.com/request-quote/'
        ];
        
        contactUsLink.forEach((link) => {
          if (link.href === contactLinksMatch[0] || link.href === contactLinksMatch[1]) {
            const linkparameter = '?product-info=true';
            link.href = contactLinksMatch[0] + linkparameter;
          }
        });
    }

    fetchAvailability(variantId) {
        if (!variantId) {
            return;
        }

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
            rootUrl += "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
            .then(response => response.text())
            .then(text => {
                const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('.shopify-section');
                this.renderPreview(sectionInnerHTML);
                const pickUpAvailability  = document.querySelector(".pickup-availability-preview");
                const productTitle = document.querySelector("h1.product-info-heading")?.textContent;
                const productSKU = document.getElementById("variant-selected-sku")?.textContent;

                updatePDPContactLink(pickUpAvailability, productTitle, productSKU);
            })
            .catch(e => {
                const button = this.querySelector('button');
                if (button) {
                    button.removeEventListener('click', this.onClickRefreshList);
                }
                this.renderError();
            });
    }

    onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) {
            drawer.remove();
        }

        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
            this.innerHTML = "";
            this.removeAttribute('available');
            return;
        }

        // Actualiza el innerHTML con el contenido recibido
        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const titleElement = this.querySelector('.pickup-availability-title');
        const descriptionElement = this.querySelector('.pickup-availability-time');
        const buttonElement = this.querySelector('.pickup-availability-button-customize-btn');
        const urlElement = this.querySelector('.pickup-availability-button-customize-btn');
        
        if (titleElement && this.dataset.title) {
            titleElement.textContent = this.dataset.title;
        }
        if (descriptionElement && this.dataset.description) {
            descriptionElement.textContent = this.dataset.description;
        }
        if (buttonElement && this.dataset.labelbutton) {
            buttonElement.textContent = this.dataset.labelbutton;
        }
        if (buttonElement && this.dataset.url) {
            buttonElement.href = this.dataset.url;
        }
        
        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
    }
}

if (!customElements.get('pickup-availability')) {
    customElements.define('pickup-availability', PickupAvailability);
}

if (!customElements.get('pickup-availability-drawer')) {
    class PickupAvailabilityDrawer extends DrawerModal {
        constructor() {
            super();
        }
    }

    customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);
}
